<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-word-wrap`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 011 1v38a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h2zm36 0a1 1 0 011 1v38a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1h2zm-19 6c6.627 0 12 5.373 12 12s-5.373 12-12 12h-2v4.046a1.4 1.4 0 01-.235.775l-.082.111a1.4 1.4 0 01-1.854.282l-.116-.085-7.389-6.045a1.4 1.4 0 01-.106-2.071l.106-.097 7.39-6.045a1.4 1.4 0 012.28.949l.006.134V30h2a8 8 0 100-16h-9a1 1 0 01-1-1v-2a1 1 0 011-1h9z"/></svg>
</template>
<script>

export default {
  name: 'IconWordWrap',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
